import Barba from 'barba.js';
import {TimelineLite, TweenMax} from 'gsap';
import 'jquery.stellar/jquery.stellar';
import 'particles.js';
import SmoothScroll from 'smoothscroll-for-websites';
import Swiper from 'swiper';
import CustomEase from './gsap/CustomEase';

import particlesjsConfig from './particlesjs-config';

const { __ } = wp.i18n;

var Arcys = Arcys || {},
    timeline = timeline || {},
    slider = slider || {};

window.appRecaptcha = function () {
    if (jQuery('body.contact #captcha_form')) {
        appRecaptchaRender(jQuery('body.contact'));
    }
};

var appRecaptchaRender = function (elParent) {
    var select = elParent.find('.cc_recaptcha');
    if (select.length) {
        select.each(function (i, e) {
            grecaptcha.render(e, {
                'sitekey': '6Le0aiUUAAAAAL_V9FzdFqv7M1QEPZZJXbM18f7b',
            });
        });
    }
};

var displayAccordionContent = function () {
    const accordionsTitle = document.querySelectorAll('.accordion-title');
    if (accordionsTitle) {
        accordionsTitle.forEach(function(accordionTitle, accordionContent) {
            accordionTitle.addEventListener('click', function(e) {
                e.preventDefault();
                this.parentNode.classList.toggle('on');
                accordionsTitle.forEach(function(accordionTitle2, accordionContent2) {
                    if ( accordionContent !== accordionContent2 ) {
                        accordionTitle2.parentNode.classList.remove('on');
                    }
                });
            });
        });
    }
};

var sliderNewsHome = function () {
  const newsSlider = new Swiper('.swiper-news-container', {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: false,
      loop: true,
      calculateHeight:true,
      grabCursor: true,
      pagination: '.swiper-pagination',
      paginationClickable: true,

  });
  if (document.querySelector('.swiper-button-prev')) {
      document.querySelector('.swiper-button-prev').addEventListener('click', function(e){
          e.preventDefault()
          newsSlider.swipePrev()
      });
  };
  if (document.querySelector('.swiper-button-next')) {
      document.querySelector('.swiper-button-next').addEventListener('click', function(e){
          e.preventDefault()
          newsSlider.swipeNext()
      });
  };
};


Arcys.main = (function ($) {
    var _init = function () {
        _app.init();
    };

    var _app = {
        init: function () {
            _app.activeMenu();
            _textImage.schema();

            if (_app.msieversion() == false && $('#frieze').length > 0) {
                _homepageNosMetiers.open();
            }

            if ($('body').hasClass('page-template-page-references')) {
                _references.initSlider();
            }

            if ($('body').hasClass('page-template-hub')) {
                _hub.frise();
            }

            if ($('body').hasClass('page-template-contact')) {
                _contact.init();
                displayAccordionContent();
            }

            setTimeout(function () {
                _app.initBackground();
            }, 500);

            if ($('body').hasClass('home')) {
                setTimeout(function () {
                    sliderNewsHome();
                    if (document.querySelector('.swiper-button-prev')) {
                       if( document.querySelector('.swiper-button-prev').classList.contains('d-none') ) {
                           document.querySelector('.swiper-button-prev').classList.remove('d-none');
                       }
                    }
                    if (document.querySelector('.swiper-button-next')) {
                        if( document.querySelector('.swiper-button-next').classList.contains('d-none') ) {
                            document.querySelector('.swiper-button-next').classList.remove('d-none');
                        }
                    }
                }, 700);
            }

            _app.stellar();
        },
        activeMenu: function () {
            if ($('.main-menu ul .active').length > 0) {
                var getActive = $('.main-menu ul').find('.active')[0];
                $('.main-menu .active-item').css({
                    'left': getActive.offsetLeft + 'px',
                    'width': getActive.clientWidth + 'px',
                });
            } else {
                $('.main-menu .active-item').css({'left': '0px', 'width': '0px'});
            }
        },
        initBackground: function () {
            $('#background').css('height', ($('body > div > nav').outerHeight() + $('main > header.header').outerHeight()) + 'px');
        },
        particles: function () {
            particlesJS('particles-js', particlesjsConfig);
        },
        barba: function () {
            Barba.Pjax.start();

            Barba.Dispatcher.on('newPageReady', function (currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {
                var getBodyClass = newPageRawHTML.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', newPageRawHTML),
                    bodyClasses = $(getBodyClass).filter('notbody').attr('class');

                $('body').attr('class', bodyClasses);

                var getRightNav = $(newPageRawHTML).filter('#barba-wrapper')[0].children[0].children[2].children[0].innerHTML;
                $('nav .right-nav .languages').html(getRightNav);

                $('.main-menu > .menu li').removeClass('active');
                $('.main-menu > .menu li a').each(function () {
                    var el = $(this);
                    if (el.attr('href') == window.location.href) {
                        if (!el.parent().parent().hasClass('sub-menu')) {
                            el.parent().addClass('active');
                        } else {
                            el.parent().addClass('active').parent().parent().addClass('active');
                        }
                    }
                });
            });

            var FadeTransition = Barba.BaseTransition.extend({
                start: function () {
                    Promise
                        .all([this.newContainerLoading, this.fadeOut()])
                        .then(this.fadeIn.bind(this));

                    $('html, body').animate({
                        scrollTop: 0,
                    });

                    if ($('#search-container').hasClass('visible')) {
                        $('#search-container').removeClass('visible');
                        setTimeout(function () {
                            $('#search-container .row > div form, #search-container .row > div .listing').removeClass('searched');
                            $('#search-container .row > div form input').val('');
                            $('#search-container .row > div .listing .content-article').html('');
                        }, 500);
                    }

                    if ($(window).width() < 769) {
                        $('nav .main-menu, .burger').removeClass('open');
                        $('nav .right-nav').removeClass('visible');
                    }
                },
                fadeOut: function () {
                    return $(this.oldContainer).animate({opacity: 0}).promise();
                },
                fadeIn: function () {
                    var _this = this;
                    var $el = $(this.newContainer);

                    $(this.oldContainer).hide();

                    $el.css({
                        visibility: 'visible', opacity: 0,
                    });

                    $el.animate({opacity: 1}, 400, function () {
                        _this.done();
                        if ($('.cc_recaptcha').length) {
                            appRecaptchaRender(jQuery('body.contact'));
                        }
                    });
                },
            });

            Barba.Pjax.getTransition = function () {
                return FadeTransition;
            };

            Barba.Dispatcher.on('transitionCompleted', function () {
                _app.init();
                _app.showContent();
                _app.smooth();

                $(window).data('plugin_stellar').destroy();
                $(window).data('plugin_stellar').init();

                $('#cube').css('top', '-241.84px');
            });
        },
        smooth: function () {
            SmoothScroll({
                stepSize: 150,
                animationTime: 1200,
                keyboardSupport: true,
                arrowScroll: 150,
            });
        },
        showContent: function () {
            if ($(window).width() > 767) {
                _app.splitText($('header .row .sub-title'), 1);
                _app.splitText($('header .row h1'), 1);
            }

            setTimeout(function () {
                $('nav').addClass('visible');
                $('main > header, main > section').addClass('visible');
            }, 10);
        },
        splitText: function (element, time) {
            var obj = element, text = obj.text(), sentence, parsed = '';

            sentence = text.split(' ');
            obj.empty();
            for (let word in sentence) {
                var wordTag = document.createElement('span');
                wordTag.className = 'word';
                wordTag.innerHTML = sentence[word] + ' ';
                obj.append(wordTag);
            }

            element.find('.word').each(function () {
                var getWord = $(this), getLetter = getWord.text(), someLetter = getLetter.split('');

                getWord.empty();
                for (let letter in someLetter) {
                    var addSpan = document.createElement('span');
                    addSpan.className = 'letter';
                    addSpan.innerHTML = someLetter[letter];
                    getWord.append(addSpan);
                }
            });

            var cpt = 0;
            element.find('.word').each(function () {
                $(this).find('.letter').each(function () {
                    var formattedNumber = ('0' + cpt * 3).slice(-2);
                    $(this).css('transition-delay', time + '.' + formattedNumber + 's');
                    cpt++;
                });
            });
        },
        ajaxSearch: function () {
            var search = $('#search-form #search').val();
            var articlesContainer = $('#search-container .listing .content-article');


            var data, pag, url = window.location.origin + '?s=' + encodeURI(search), jqxhr = $.ajax(url)
                .done(function () {
                    articlesContainer.html('');
                })
                .fail(function () {
                    alert('error');
                })
                .always(function (response) {
                    data = $(response).filter('#barba-wrapper')[0].getElementsByClassName('barba-container')[0].children[0].children[0].children[0].innerHTML;
                    $('#search-container .row > div .listing').addClass('searched');
                    if (data != '') {
                        articlesContainer.html(data);
                    } else {
                        var noResult = 'Pas de résultats';
                        if ($('body').hasClass('en')) {
                            noResult = 'No result';
                        }
                        articlesContainer.html('<p class="no-result">' + noResult + '</p>');
                    }
                });

            return false;
        },
        msieversion: function () {
            var ua = window.navigator.userAgent, msie = ua.indexOf('MSIE ');

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                $('#barba-wrapper, aside#background').addClass('is-ie');
                return false;
            }
        },
        stellar: function () {
            $(window).stellar({
                horizontalScrolling: false,
            });
        },
    };

    var _references = {
        initSlider: function () {
            if ($('.slider-references').length > 0) {
                setTimeout(function () {
                    slider.references = new Swiper('.slider-references', {
                        mode: 'horizontal',
                        loop: false,
                        calculateHeight: true,
                        speed: 500,
                        simulateTouch: false,
                        autoResize: false,
                        onSwiperCreated: function () {
                            _references.lightsManager();
                        },
                        onSlideChangeEnd: function () {
                            _references.lightsManager();
                        },
                    });
                }, 10);
            }
        },
        lightsManager: function () {
            var tags = $('.slider-references .swiper-wrapper .swiper-slide-active').attr('data-tags');
            tags = tags.length ? tags.split(' ') : false;
            $('.circles #tags .light').removeClass('no-cursor active');
            if (tags) {
                tags.forEach(tag =>{
                    if ($('.references .slider-references .swiper-slide-active .infos .' + tags[tag] + ' .close').siblings().length == 0) {
                        $('.circles #tags .list-lights #' + tags[tag]).addClass('no-cursor');
                    }
                    $('.circles #tags .list-lights #' + tags[tag]).addClass('active');
                });
            }
        },
    };

    var _home = {
        movie: function () {
            var videos = $('#video-datas');
            var sources = videos.toArray().map(function (video) {
                return JSON.parse(video.textContent);
            });

            sources.forEach(function (source, index) {
                var video = videos[index];
                if ($(window).width() > 1024) {
                    if (video.inserted) {
                        return;
                    }

                    var src = source.videos.map(function (s) {
                        return '<source src="' + s.src + '" type="' + s.type + '">';
                    });

                    var attributes = [];
                    for (var attr in source.attributes) {
                        if (source.attributes.hasOwnProperty(attr)) {
                            attributes.push(attr + '="' + source.attributes[attr] + '"');
                        }
                    }

                    $(video).after('<video muted ' + attributes.join(' ') + '>' + src + '</video>');
                    video.inserted = true;
                } else {
                    $(video).siblings('video').remove();
                    video.inserted = false;
                }
            });


            if (sessionStorage.getItem('videoPlayed') != 'true' && $('body').hasClass('home') && $(window).width() > 1024) {
                var video = $('#movie video')[0];
                $('#movie').show();
                video.play();
                sessionStorage.setItem('videoPlayed', 'true');

                video.onended = function (e) {
                    $('#movie').fadeOut(400);
                    _app.showContent();
                };
            } else {
                _app.showContent();
            }
        },
    };

    var _homepageNosMarches = {
        main: function ($this) {
            var tl = new TimelineLite({
                onStart: _homepageNosMarches.onStart($this),
                onComplete: _homepageNosMarches.onComplete,
                onReverseComplete: _homepageNosMarches.onReverseComplete,
            });

            var activeSprite = $this.find('.sprite');
            var activeCross = $this.find('.cross');
            var activeBall = $this.find('.ball');
            var activeStroke = $this.find('.stroke');
            var activeTxt = $this.find('.txt');
            var bgFrom = activeSprite.data('from');
            var bgTo = activeSprite.data('to');
            var spriteNoActive = $('.sprite-container:not(.active)');

            // changement de BG sur l'active sprite
            tl
                .to(activeBall, 0.5, {
                    opacity: '0',
                })
                .to(activeSprite, 0, {
                    backgroundImage: 'url(' + bgTo + ')',
                })
                .add('step01', '-=0')
                // fadeOut des container inactifs et de la boule colorée
                .to(spriteNoActive, 0.5, {
                    opacity: '0',
                }, 'step01')
                // réduction des container inactifs
                // ++ agrandissement du container actif en largeur et en hauteur
                // ++ zoom dans l'illustration
                .to(spriteNoActive, 1, {
                    padding: '0', width: '0',
                }, 'step01')
                .to($this, 1, {
                    width: '100%', opacity: '1',
                }, 'step01')
                .to(activeSprite, 1, {
                    // height: '386px',
                    // backgroundPosition: '0px -350px'
                    // backgroundPosition: '0% 75%',
                    // backgroundSize: '100% 200%'
                }, 'step01')
                .add('step02')
                // display block puis fadeIn de la croix
                .to(activeCross, 0, {
                    display: 'block',
                }, 'step02')
                .to(activeCross, 1, {
                    opacity: '0.5',
                }, 'step02')
                // réapparition de la boule colorée
                .to(activeBall, 0, {
                    top: '61px', left: '269px',
                }, 'step02')
                .to(activeBall, 0.5, {
                    opacity: '1',
                }, 'step02')
                // apparition du trait
                .to(activeStroke, 1, {
                    width: '274.5px',
                }, 'step02')
                .to(activeTxt, 0, {
                    display: 'block',
                })
                .to(activeTxt, 1.5, {
                    opacity: '1',
                });
            return tl;
        },
        open: function ($this) {
            if (!$this.hasClass('active')) {
                $this.addClass('open');
                $($this).siblings().addClass('hidden');
                $($this).parent().siblings('.cta').css('opacity', '0');
            }
        },
        close: function ($this) {
            $('body').addClass('on-anim');
            $this.removeClass('open');
            $($this).siblings().removeClass('hidden');
            setTimeout(function () {
                $($this).parent().siblings('.cta').css('opacity', '1');
            }, 500);
        },
        onStart: function ($this) {
            $('body').addClass('on-anim');
            $('section.nos-marches .sprite-container').removeClass('active');
            $this.addClass('active');
        },
        onComplete: function () {
            $('body').removeClass('on-anim');
        },
        onReverseComplete: function () {
            $('.sprite-container.active').removeClass('active');
            $('body').removeClass('on-anim');
        },
    };

    var _homepageNosMetiers = {
        main: function () {
            var tl = new TimelineLite();
            var frieze = $('.frieze');
            var timeline = frieze.find('#timeline');
            var items = frieze.find('.item');
            tl
                .to(timeline, 1.5, {
                    width: '100%', ease: CustomEase.create('custom', 'M0,0 C0.524,0.198 0.036,0.998 1,1'),
                })
                .add('endTimeline', '-=1');

            items.each(function (index, element) {
                var delay = 0.2 * index;
                tl
                    .add('startAnimElement' + index, 'endTimeline+=' + delay)
                    .to($(element).find('svg.ball'), 1, {
                        opacity: 1,
                    }, 'startAnimElement' + index)
                    .to($(element).find('.item__stroke'), 0.7, {
                        height: '49px',
                    }, 'startAnimElement' + index)
                    .to($(element).find('.item__title'), 1, {
                        opacity: 1,
                    }, 'startAnimElement' + index + '+=0.5');
            });
            return tl;
        },
        open: function () {
            timeline.nosMarches = _homepageNosMetiers.main();
            timeline.nosMarches.play();
        },
    };

    var _hub = {
        frise: function () {
            var getSpan = $('.frise .path span');
            if ($(window).width() > 767) {
                for (var key = 2; key < getSpan.length; key++) {
                    getSpan.eq(key).css('left', 'calc(100% / 12 * (5 + ' + (key * 2) + ')');
                }
            } else {
                for (var key = 2; key < getSpan.length; key++) {
                    getSpan.eq(key).css('left', 'calc(100% + 100px)');
                }
            }
        },
        slidePrev: function (element) {
            var getCurrent = element.siblings('.active').attr('data-index');
            if (getCurrent > 1) {
                setTimeout(function () {
                    $('.frise .content-frise article[data-index="' + getCurrent + '"]').css('visibility', 'hidden').prev().css('visibility', 'visible');
                }, 500);
                $('.frise .content-frise article[data-index="' + getCurrent + '"]').removeClass('active');
                $('.frise .content-frise article[data-index="' + getCurrent + '"]').prev().addClass('active');

                if ($(window).width() > 767) {
                    $('.frise .path span.active').removeClass('active').css('left', 'calc(100% / 12 * (5 + ' + (getCurrent * 2) + ')').prev().addClass('active').removeClass('previous');
                    for (var i = getCurrent; i < $('.frise .content-frise article').length + 1; i++) {
                        $('.frise .path span').eq(i).css('left', 'calc(100% / 12 * (7 + ' + (i * 2 - getCurrent) + ')');
                    }
                } else {
                    $('.frise .path span.active').removeClass('active').css('left', 'calc(100% + 100px)').prev().addClass('active').removeClass('previous');
                }
            }
        },
        slideNext: function (element) {
            var getCurrent = element.siblings('.active').attr('data-index');
            if (getCurrent < $('.frise .content-frise article').length) {
                setTimeout(function () {
                    $('.frise .content-frise article[data-index="' + getCurrent + '"]').css('visibility', 'hidden').next().css('visibility', 'visible');
                }, 500);
                $('.frise .content-frise article[data-index="' + getCurrent + '"]').removeClass('active');
                $('.frise .content-frise article[data-index="' + getCurrent + '"]').next().addClass('active');
                if ($(window).width() > 767) {
                    $('.frise .path span.active').addClass('previous').css('left', (65 * getCurrent) + 'px').next().addClass('active');
                    for (var i = getCurrent; i < $('.frise .content-frise article').length; i++) {
                        $('.frise .path span').eq(i + 1).css('left', 'calc(100% / 12 * (5 + ' + (i * 2 - getCurrent) + ')');
                    }
                } else {
                    $('.frise .path span.active').addClass('previous').css('left', '-100px').next().addClass('active');
                }
                $('.frise .path span.previous').removeClass('active');
            }
        },
    };

    var _contact = {
        init: function () {
            if ($('select#objet').val() == 'info' || $('select#objet').val() == 'candidature') {
                $('form fieldset .objet-listing span').html($('select#objet option:selected').html());
            }
            $('form fieldset input').each(function () {
                if ($(this).val() != '') {
                    $(this).parent().addClass('filled');
                }
            });
        },
        objet: function (value) {
            if (value == 'candidature') {
                $('input#telephone')[0].required = true;
                $('input#telephone').siblings('label').html(__( 'Numéro de téléphone*', 'arcys' ));
                $('.get-docs').slideDown();
            } else {
                $('input#telephone')[0].required = false;
                $('input#telephone').siblings('label').html(__( 'Numéro de téléphone', 'arcys' ));
                $('.get-docs').slideUp();

                $('.get-docs input[type="file"]').each(function () {
                    $(this).val('');
                });
            }

            if (value == 'info') {
                $('fieldset.text-info').css('opacity', '1');
                $('fieldset.radio').slideDown();
            } else {
                $('fieldset.text-info').css('opacity', '0');
                $('fieldset.radio').slideUp();

                $('fieldset.radio input[type="radio"]').each(function () {
                    $(this)[0].checked = false;
                });
            }
        },
    };

    var _textImage = {
        schema: function () {
            $('img.schema').each(function () {
                $(this).css('width', $(window).width() + 'px');
            });

            if ($(window).width() > 767) {
                $('img.schema').each(function () {
                    $(this).attr('src', $(this).attr('data-src'));
                });
            } else {
                $('img.schema').each(function () {
                    $(this).attr('src', $(this).attr('data-mobile'));
                });
            }
        },
        video: function (videoContainer) {
            var src = videoContainer.data('youtube');
            videoContainer.append('<iframe src="' + src + '" allowfullscreen frameborder="0"></iframe>');
            videoContainer.find('div').fadeOut();
            videoContainer.find('img').fadeOut();
            videoContainer.addClass('play');
        },
    };

    return {
        init: _init,
        leaveMenu: _app.activeMenu,
        homepageNosMetiersOpen: _homepageNosMetiers.open,
        homepageNosMarchesOpen: _homepageNosMarches.open,
        homepageNosMarchesClose: _homepageNosMarches.close,
        hubSlidePrev: _hub.slidePrev,
        hubSlideNext: _hub.slideNext,
        loadYoutube: _textImage.video,
        showContent: _app.showContent,
        fieldObject: _contact.objet,
        appSearch: _app.ajaxSearch,
        particles: _app.particles,
        barba: _app.barba,
        smooth: _app.smooth,
        movie: _home.movie,
        isNotIe: _app.msieversion,
    };

})(jQuery);

jQuery(function ($) {
    Arcys.main.init();

    Arcys.main.particles();
    Arcys.main.barba();
    Arcys.main.movie();

    $(window).on('scroll', function () {
        if ($('body').hasClass('home')) {
            if ($('#frieze').offset().top - $(window).height() < $(document).scrollTop()) {
                Arcys.main.homepageNosMetiersOpen();
            }
        }
    });

    // if($('body').hasClass('error404')){
    //     setTimeout(function(){
    //         $('.error-overlay').css('bottom', $('#error-movie').height()+'px');
    //         $('#error-movie')[0].play();
    //     }, 2000);
    // }

    SmoothScroll({
        stepSize: 150,
        animationTime: 550,
        keyboardSupport: true,
        arrowScroll: 150,
    });

    var windowWidth = $(window).width();

    // Resize Event
    $(window).on('resize', function () {

        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() != windowWidth) {

            // Update the window width for next time
            windowWidth = $(window).width();

            // Do stuff here
            Arcys.main.init();
        }

        // Otherwise do nothing

    });

    if ($(window).width() > 1024) {
        $(document).on('mouseover', '.main-menu ul li', function () {
            var getActive = $(this)[0];
            $('.main-menu .active-item').css({
                'left': getActive.offsetLeft + 'px',
                'width': getActive.clientWidth + 'px',
            });
        });

        $(document).on('mouseleave', '.main-menu ul', function () {
            Arcys.main.leaveMenu();
        });
    }

    $(document).on('click', '.scroll', function () {
        $('html, body').animate({
            scrollTop: $('main > header.header').height() + 143,
        });
    });

    /*
     * Page template => références
     *
     * */
    $(document).on('click', '.circles #tags .light.active', function () {
        var getElement = $(this).attr('id'),
            getActiveSlide = $('.slider-references .swiper-wrapper .swiper-slide-active .infos');

        if (getActiveSlide.find('.' + getElement).find('.close').siblings().length > 0) {
            $('.circles #tags .light').removeClass('clicked');
            $(this).addClass('clicked');
            getActiveSlide.addClass('visible');
            getActiveSlide.find('.' + getElement).css('visibility', 'visible');
            $('header .row .references .slider-references').css('pointer-events', 'all');
        }
    });

    $(document).on('click', '.slider-references .swiper-wrapper .swiper-slide .infos .close', function () {
        var getElementsToHide = $('.slider-references .swiper-wrapper .swiper-slide .infos');

        $('.circles #tags .light').removeClass('clicked');
        getElementsToHide.removeClass('visible');
        setTimeout(function () {
            getElementsToHide.find('> div').css('visibility', 'hidden');
        }, 1000);
        $('header .row .references .slider-references').css('pointer-events', 'none');
    });

    $(document).on('click', '.controls .swipe-prev', function () {
        $('.slider-references .swiper-wrapper .swiper-slide .infos').removeClass('visible').find('> div').css('visibility', 'hidden');
        $('.circles #tags .light').removeClass('clicked');
        slider.references.swipePrev();
    });

    $(document).on('click', '.controls .swipe-next', function () {
        $('.slider-references .swiper-wrapper .swiper-slide .infos').removeClass('visible').find('> div').css('visibility', 'hidden');
        $('.circles #tags .light').removeClass('clicked');
        slider.references.swipeNext();
    });

    $(document).on('click', 'section .row article figure', function () {
        $('html, body').animate({
            scrollTop: 150,
        });
        $('.slider-references .swiper-wrapper .swiper-slide .infos').removeClass('visible').find('> div').css('visibility', 'hidden');
        $('.circles #tags .light').removeClass('clicked');
        slider.references.swipeTo($(this).index());
    });


    /*
     * Animation Nos Marchés - ouverture
     *
     * */
    $(document).on('click', 'section.nos-marches .sprite-container', function () {
        Arcys.main.homepageNosMarchesOpen($(this));
    });

    /*
     * Animation Nos Marchés - fermeture
     *
     * */
    $(document).on('click', 'section.nos-marches .sprite-container .cross', function (e) {
        Arcys.main.homepageNosMarchesClose($(this).parent().parent().parent());
        return false;
    });

    $(document).on('click', '.frise .content-frise .previous', function () {
        var elt = $(this);
        Arcys.main.hubSlidePrev(elt);
    });

    $(document).on('click', '.frise .content-frise .next', function () {
        var elt = $(this);
        Arcys.main.hubSlideNext(elt);
    });

    $(document).on('click', '[data-youtube] .play', function () {
        Arcys.main.loadYoutube($(this).parent());
    });

    $(document).on('click', '.listing article .trigger', function () {
        var elt = $(this);

        $('.popin > div').html(elt.parent().html());
        $('.popin > div .trigger').html('Refermer');
        $('.popin').fadeIn();

        appRecaptchaRender($('.popin > div'));
        displayAccordionContent();

        $('#barba-wrapper').addClass('blur');
    });

    $(document).on('click', '.popin > div .trigger', function () {
        var elt = $(this);
        $('.popin > div').html('');
        $('.popin').fadeOut();
        $('#barba-wrapper').removeClass('blur');
    });

    $(document).on('change', 'form fieldset input', function () {
        if ($(this).val() != '') {
            $(this).parent().addClass('filled');
        } else {
            $(this).parent().removeClass('filled');
        }
    });

    $(document).on('click', 'nav .right-nav .search', function () {
        $('#search-container').addClass('visible');
        $('#search-container').find('form').find('input').focus();
        $('body').addClass('fixed');
    });

    $(document).on('click', '#search-container .close', function () {
        $('#search-container').removeClass('visible');
        setTimeout(function () {
            $('#search-form, #search-container .row > div .listing').removeClass('searched');
            $('#search-container .row > div .listing .content-article').html();
            $('#search-container .row > div form input#search').val('');
        }, 500);
        if ($(window).width() > 767) {
            $('body').removeClass('fixed');
        }
    });

    $('#search-form').on('submit', function (e) {
        e.preventDefault();
        $('#search-form').addClass('searched');
        Arcys.main.appSearch();
        return false;
    });

    $(document).on('click', '#movie .skip span', function () {
        var video = $('#movie video')[0];
        $('#movie').fadeOut(400);
        Arcys.main.showContent();
        setTimeout(function () {
            video.pause();
        }, 400);
    });

    $(document).on('click', 'nav .burger', function () {
        $(this).toggleClass('open');
        $('nav .main-menu').toggleClass('open');
        $('body').toggleClass('fixed');
        $('nav .right-nav').toggleClass('visible');
    });

    $(document).on('click', 'nav .main-menu ul li a', function () {
        if ($(window).width() < 768) {
            $('nav .burger').removeClass('open');
            $('nav .main-menu').removeClass('open');
            $('body').removeClass('fixed');
            $('nav .right-nav').removeClass('visible');
        }
    });

    $(document).on('click', 'form fieldset .objet-listing span', function () {
        $(this).siblings('ul').slideToggle(400);
    });

    $(document).on('click', 'form fieldset .objet-listing ul li', function () {
        var element = $(this).parent().parent();
        element.find('ul').slideUp(400);
        element.find('span').html($(this).html());

        $('select#objet').val($(this).attr('data-option'));

        if ($('form fieldset select#objet').val() == 'info') {
            $('input#societe').attr('required', 'required').parent().show();
            $('input#fonction').attr('required', 'required').parent().show();
            $('input#cv').removeAttr('required');
            $('input#lm').removeAttr('required');
            $('input#controle-commande').attr('required', 'required');
        } else {
            $('input#societe').removeAttr('required').parent().hide();
            $('input#fonction').removeAttr('required').parent().hide();
            $('input#cv').attr('required', 'required');
            $('input#lm').attr('required', 'required');
            $('input#controle-commande').removeAttr('required');
        }

        Arcys.main.fieldObject($(this).attr('data-option'));
    });

    $(document).on('click', 'section .sort a, section .row > div .pagination .nav-links a', function () {
        var elt = $(this), getFilter = elt.attr('data-filter');

        $('section .sort a').removeClass('active');
        elt.addClass('active');

        var data, pag, url = $(this).attr('href'), jqxhr = $.ajax(url)
            .done(function () {
                $('section .row > div article').addClass('hidden');
            })
            .fail(function () {
                alert('error');
            })
            .always(function (response) {
                data = $(response).filter('#barba-wrapper')[0].getElementsByClassName('barba-container')[0].children[1].children[1].children[0].innerHTML;
                pag = $(response).filter('#barba-wrapper')[0].getElementsByClassName('barba-container')[0].children[1].children[0].children[0].children[1];
                setTimeout(function () {
                    $('.archive section .row .listing').html('');
                    $('.archive section .row .listing').append(data);
                    $('section .row > div .pagination').remove();
                    $('section .row .get-pagination').append(pag);

                    //appRecaptcha();

                    $('section .row > div .pagination').css('opacity', '1');
                    Arcys.main.smooth();
                }, 650);
            });
        return false;
    });

    $(document).on('mouseenter', '.cta, .childs .content a', function () {
        TweenMax.to($(this), .5, {'background-position': '100% 0'});
    });

    $(document).on('mouseleave', '.cta, .childs .content a', function () {
        TweenMax.to($(this), .5, {'background-position': '0% 0'});
    });

    $(document).on('click', 'nav .right-nav .languages span', function () {
        $(this).siblings('ul').slideToggle();
    });

    $(document).on('click', 'nav .right-nav .languages ul li a', function () {
        $(this).parent().parent().slideUp();
        $('nav .right-nav .languages span').html($(this).html());
    });
});
